<template>
  <router-view />
</template>

<script setup>
// App root component
</script>
